module.exports = __webpack_public_path__ + "img/PV.669a4a34.svg";